import { z } from "zod";

export const createGroupSchema = z
	.object({
		name: z
			.string()
			.min(2, { message: "Group name must be at least 2 characters" })
			.max(50, { message: "Group name must be at most 50 characters" }),
		description: z.string().max(500).optional(),
	})
	.strict();

export type CreateGroupPayload = z.infer<typeof createGroupSchema>;
